<template>
  <DataListStateful
    title="Пользователи"
    resource="users"
    store="users"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id" },
        { title: "Имя", name: "title" },
        { title: "Login", name: "username" },
        { title: "Email", name: "email" },
        {
          title: "Роль",
          name: "roles",
          valueFn(item) {
            return Array.isArray(item.Roles) && item.Roles.length > 0
              ? [...new Set(item.Roles.map((i) => i.Title))].join("; ")
              : "";
          },
        },
        {
          title: "",
          name: "hasEmployee",
          type: "label",
          falseTitle: "Без сотрудника",
        },
      ],
      filter: {
        title: {
          title: "Имя",
          type: "text",
        },
        username: {
          title: "Login",
          type: "text",
        },
        email: {
          title: "Email",
          type: "text",
        },
        roles: {
          title: "Роль",
          type: "enum",
          resource: "user-roles",
        },
        hasEmployee: {
          title: "Без сотрудника",
          type: "bool",
        },
      },
    };
  },
};
</script>
